// Hide spacer-only elements without modifying the merchant's page content.
function tidyShippingInformation() {
  document.querySelectorAll('.og-shipping-information .page-content p, .og-shipping-information .page-content div').forEach((element) => {
    if (!element.textContent.trim() && !element.querySelector('img, svg, iframe, input, button, video, table')) {
      element.hidden = true;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tidyShippingInformation, { once: true });
} else {
  tidyShippingInformation();
}
document.addEventListener('shopify:section:load', tidyShippingInformation);
